import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  SelectField,
  DeleteButton,
  EditButton,
} from "react-admin";

const UserList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <EmailField source="email" />
      <TextField source="name" />
      <TextField source="role" />
      <SelectField
        source="userStatus"
        choices={[
          { id: "notVerified", name: "unverified" },
          { id: "verified", name: "verified" },
          { id: "disabled", name: "disabled" },
        ]}
      />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export default UserList;
